<template>
  <div
    class="flex gap-1 pt-2 sm:max-w-2xl sm:mx-auto my-3 px-1 sm:px-0 justify-center">
    <div class="px-1 flex flex-col gap-1">
      <div class="flex gap-2">
      <SocialShare
        v-for="network in ['linkedin', 'facebook', 'telegram', 'twitter', 'whatsapp', 'email']"
        :key="network"
        :network="network"
        :styled="true"
        :label="false"
        :url="`${useRequestURL().protocol}//${useRequestURL().host}${route.path}`"
        :title="platform + ' – ' + spot.title"
        :image="useImageUrl(spot.gallery[0].imageId, 'large')"
        :hashtags="`#${platform}`"
      />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  spot: SpotDetail;
}>();
const route = useRoute();
const platform = usePlatformSettings().platformName;

</script>
<style lang="postcss" scoped>

.social-share-button {
  color: #fff;
}

</style>
